<script>
import service from '@/service';
import { parse } from 'date-fns';
import PlacilaModal from '@/components/PlacilaModal';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import settings from '@/settings.js';
import * as Ladda from 'ladda';
import EditPrilivModal from '@/components/Modals/EditPrilivModal';
import NaloziDatotekoModal from '@/components/Modals/NaloziDatotekoModal';
import ZeljenaIzstavitevRacunaModal from '@/components/Modals/ZeljenaIzstavitevRacunaModal';
import DodajanjeStKupoprodajnePogodbeModal from '@/components/Modals/DodajanjeStKupoprodajnePogodbeModal';

const znasekRegex = /[+-]{0,1}[0-9.,]{1,10}/;

export default {
	components: {
		Loading,
		'placila-modal': PlacilaModal,
		'edit-priliv-modal': EditPrilivModal,
		'nalozi-datoteko-modal': NaloziDatotekoModal,
		'zeljena-izstavitev-racuna-modal': ZeljenaIzstavitevRacunaModal,
		'dodajanje-st-kupoprodjane-pogodbe-modal': DodajanjeStKupoprodajnePogodbeModal
	},
	methods: {
		showModal: function (id, ogrodje, vozilo, prodajalecId, prodajalecName, kupec, starost, datumProdaje, datumPlaniraneDobave, financiranjeRci, koncesijaDatum, autoLoadPlacila) {
			this.isLoading = true;
			this.item_id = id;
			this.ogrodje = ogrodje;
			this.vozilo = vozilo;
			this.prodajalec_id = prodajalecId;
			this.prodajalec_name = prodajalecName;
			this.kupec = kupec;
			this.starost = starost;
			if (datumProdaje) {
				this.datum_nakupa = datumProdaje;
			}
			if (datumPlaniraneDobave) {
				this.datum_planirane_dobave = datumPlaniraneDobave;
			}
			this.financiranje_rci = financiranjeRci;
			if (koncesijaDatum) {
				this.koncesija_datum = koncesijaDatum;
			}
			this.autoLoadPlacila = autoLoadPlacila;
			if (!this.autoLoadPlacila) {
				this.$refs.modal.show();
			}
			this.getMapa(id);
		},
		getMapa: function (itemId) {
			this.isLoading = true;
			this.initChangeNakazila = false;
			service.getMapa(itemId)
				.then(response => {
					if (response) {
						this.podaljsano_jamstvo_picked = response['mapa']['podaljsano_jamstvo'];
						this.podaljsano_jamstvo_leta = response['mapa']['podaljsano_jamstvo_leta'];
						this.podaljsano_jamstvo_km = response['mapa']['podaljsano_jamstvo_km'];
						this.podaljsano_jamstvo_znesek = Number(response['mapa']['podaljsano_jamstvo_znesek']) || null;
						this.podaljsano_jamstvo_opomba = response['mapa']['podaljsano_jamstvo_opomba'];
						this.zavarovanje_picked = response['mapa']['zavarovanje'];
						this.zavarovanje_opomba = response['mapa']['zavarovanje_opomba'];
						this.myr_picked = response['mapa']['myr'];
						this.myr_leta = response['mapa']['myr_leta'];
						this.myr_km = response['mapa']['myr_km'];
						this.myr_znesek = Number(response['mapa']['myr_znesek']) || null;
						this.myr_opomba = response['mapa']['myr_opomba'];
						this.gap_picked = response['mapa']['gap'];
						this.gap_opomba = response['mapa']['gap_opomba'];
						this.bni_picked = response['mapa']['bni'];
						this.bni_opomba = response['mapa']['bni_opomba'];
						this.bonus1 = Number(response['mapa']['bonus1']) || null;
						this.bonus2 = Number(response['mapa']['bonus2']) || null;
						this.bonus3 = Number(response['mapa']['bonus3']) || null;
						this.bonus4 = Number(response['mapa']['bonus4']) || null;
						this.bonus5 = Number(response['mapa']['bonus5']) || null;
						this.bonus6 = Number(response['mapa']['bonus6']) || null;
						this.ostali_dogovori = response['mapa']['ostali_dogovori'];
						this.nulti_picked = response['mapa']['nulti'];
						this.ciscenje_picked = response['mapa']['ciscenje'];
						this.klic_stranke = response['mapa']['klic_stranke'];
						this.st_racuna = response['mapa']['st_racuna'];
						this.datum_racuna = response['mapa']['datum_racuna'];
						this.prodajna_cena = Number(response['mapa']['prodajna_cena']) || null;
						this.skupni_znesek = Number(response['mapa']['skupni_znesek']) || null;
						this.rci_lizing = response['mapa']['rci_lizing'];
						this.rci_kredit = response['mapa']['rci_kredit'];
						this.nakazila = [];
						var nakazilaFromDb = response['mapa']['nakazila'];
						if (nakazilaFromDb !== undefined) {
							for (let nakaziloFromDb of nakazilaFromDb) {
								this.nakazila.push({
									id: nakaziloFromDb['id'],
									tip: nakaziloFromDb['tip'],
									datum: nakaziloFromDb['datum'],
									znesek: Number(nakaziloFromDb['znesek']),
									opomba: nakaziloFromDb['opomba'],
									st_kupoprodajne_pogodbe: nakaziloFromDb['st_kupoprodajne_pogodbe'],
									ujemajocPrilivId: null,
									ujemajocPrilivZnesek: null
								});
							}
						}
						this.povracila = [];
						var povracilaFromDb = response['mapa']['povracila'];
						if (povracilaFromDb !== undefined) {
							for (let povraciloFromDb of povracilaFromDb) {
								this.povracila.push({
									id: povraciloFromDb['id'],
									tip: povraciloFromDb['tip'],
									datum: povraciloFromDb['datum'],
									znesek: Number(povraciloFromDb['znesek'])
								});
							}
						}
						this.oprema = [];
						var dodatneopremeFromDb = response['mapa']['dodatneopreme'];
						if (dodatneopremeFromDb !== undefined) {
							for (let dodatnaopremaFromDb of dodatneopremeFromDb) {
								this.oprema.push({
									id: dodatnaopremaFromDb['id'],
									tip: dodatnaopremaFromDb['tip'],
									znesek: Number(dodatnaopremaFromDb['znesek']),
									opomba: dodatnaopremaFromDb['opomba'],
									datum_narocila: dodatnaopremaFromDb['datum_narocila']
								});
							}
						}
						this.datum_prodajalec_potrdil = response['mapa']['datum_prodajalec_potrdil'];
						this.datum_sekretar_potrdil = response['mapa']['datum_sekretar_potrdil'];
						this.datum_moderator_potrdil = response['mapa']['datum_moderator_potrdil'];
						this.datum_racunovodja_potrdil = response['mapa']['datum_racunovodja_potrdil'];
						this.prilivi = [];
						this.priliviBrezUjemanj = [];
						let priliviFromDb = response['mapa']['prilivi'];
						if (priliviFromDb !== undefined) {
							for (let prilivFromDb of priliviFromDb) {
								this.prilivi.push({
									id: prilivFromDb['id'],
									naziv: prilivFromDb['naziv'],
									placnik: prilivFromDb['placnik'],
									referenca: prilivFromDb['referenca'],
									vir: prilivFromDb['vir'],
									datum: prilivFromDb['datum'],
									znesek: Number(prilivFromDb['znesek'])
								});
								this.priliviBrezUjemanj.push({
									id: prilivFromDb['id'],
									naziv: prilivFromDb['naziv'],
									placnik: prilivFromDb['placnik'],
									referenca: prilivFromDb['referenca'],
									vir: prilivFromDb['vir'],
									datum: prilivFromDb['datum'],
									znesek: Number(prilivFromDb['znesek'])
								});
							}
						}
						this.povracilaData = [];
						this.povracilaDataBrezUjemanja = [];
						let povracilaDataFromDb = response['mapa']['povracilaData'];
						if (povracilaDataFromDb !== undefined) {
							for (let povraciloDataFromDb of povracilaDataFromDb) {
								this.povracilaData.push({
									id: povraciloDataFromDb['id'],
									action_name: povraciloDataFromDb['action_name'],
									chassis: povraciloDataFromDb['chassis'],
									sale_channel: povraciloDataFromDb['sale_channel'],
									creditnotedate: povraciloDataFromDb['creditnotedate'],
									amount: Number(povraciloDataFromDb['amount'])
								});
								this.povracilaDataBrezUjemanja.push({
									id: povraciloDataFromDb['id'],
									action_name: povraciloDataFromDb['action_name'],
									chassis: povraciloDataFromDb['chassis'],
									sale_channel: povraciloDataFromDb['sale_channel'],
									creditnotedate: povraciloDataFromDb['creditnotedate'],
									amount: Number(povraciloDataFromDb['amount'])
								});
							}
						}
						this.datoteke = this.addFilesTypes(response['mapa']['datoteke']);
						this.mapaExist = true;
						this.formChanged = false;
						if (response['mapa']['zeljena_izstavitev_racuna'] != null) {
							this.zeljenaIzstavitevRacuna = parse(response['mapa']['zeljena_izstavitev_racuna'], settings.dbDtFormat);
						} else {
							this.zeljenaIzstavitevRacuna = null;
						}
						this.datum_izstavitve_racuna = response['mapa']['datum_izstavitve_racuna'];
						this.stopnja_ddv = response['mapa']['stopnja_ddv'];
						this.najdiUjemanjaNakazil();
						this.najdiUjemanjaPovracil();
					} else {
						this.mapaExist = false;
						this.stopnja_ddv = settings.stopnja_ddv;
					}
					this.nakazila_to_delete = [];
					this.povracila_to_delete = [];
					this.dodatneopreme_to_delete = [];
					this.isLoading = false;
					if (this.autoLoadPlacila) {
						this.showPlacilaModal();
					}
					setTimeout(() => {
						this.initChangeNakazila = true;
					}, 1000);
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
					this.isLoading = false;
					this.$refs.modal.hide();
				});
		},
		addFilesTypes: function (datoteke) {
			for (let datoteka of datoteke) {
				let extension = datoteka.ime_datoteke.substring(datoteka.ime_datoteke.length - 4, datoteka.ime_datoteke.length).toLowerCase();
				if (extension === '.pdf') {
					datoteka.file_type = 'fa-file-pdf-o';
				} else if (extension === '.jpg' || extension === 'jpeg' || extension === '.bmp' || extension === '.png') {
					datoteka.file_type = 'fa-file-image-o';
				} else if (extension === '.xls' || extension === 'xlsx' || extension === '.csv' || extension === '.slk') {
					datoteka.file_type = 'fa-file-excel-o';
				} else if (extension === '.doc' || extension === 'docx') {
					datoteka.file_type = 'fa-file-excel-o';
				} else if (extension === '.txt') {
					datoteka.file_type = 'fa-file-text-o';
				} else if (extension === '.ppt' || extension === 'pptx') {
					datoteka.file_type = 'fa-file-powerpoint-o';
				} else {
					datoteka.file_type = 'fa-file-o';
				}
			}
			return datoteke;
		},
		click_updateData: function (evt) {
			if (this.item_id) {
				let loader = Ladda.create(this.$refs.aUpdate);
				loader.start();
				service.getMFilesInfo(this.item_id)
					.then(response => {
						loader.stop();
						if (!response.item) {
							return;
						}
						if (response.item.id !== this.item_id) {
							return;
						}
						this.st_racuna = response.item.st_racuna;
						this.datum_racuna = parse(response.item.datum_racuna, settings.dbDtFormat);
						this.skupni_znesek = Number(response.item.skupni_znesek);
					})
					.catch(error => {
						if (error) {
							console.log(error);
						}
						loader.stop();
					});
			}
		},
		click_toggleLock: function (evt) {
			this.moderatorUnlock = !this.moderatorUnlock;
		},
		onOkModal: function (evt) {
			evt.preventDefault();
			if (this.ogrodje != null && this.item_id != null) {
				this.isLoading = true;
				service.saveMapa(this.item_id, this.podaljsano_jamstvo_picked, this.podaljsano_jamstvo_leta, this.podaljsano_jamstvo_km, this.podaljsano_jamstvo_znesek, this.podaljsano_jamstvo_opomba, this.zavarovanje_picked, this.zavarovanje_opomba, this.myr_picked, this.myr_leta, this.myr_km, this.myr_znesek, this.myr_opomba, this.gap_picked, this.gap_opomba, this.bni_picked, this.bni_opomba, this.bonus1, this.bonus2, this.bonus3, this.bonus4, this.bonus5, this.bonus6, this.ostali_dogovori, this.nulti_picked, this.ciscenje_picked, this.klic_stranke, this.st_racuna, this.datum_racuna, this.prodajna_cena, this.skupni_znesek, this.rci_lizing, this.rci_kredit, this.starost, this.nakazila, this.nakazila_to_delete, this.povracila, this.povracila_to_delete, this.oprema, this.dodatneopreme_to_delete, this.stopnja_ddv)
					.then(response => {
						this.$refs.toastr.s('Mapa vozila z ogordjem ' + this.ogrodje + ' uspešno shranjena!');
						this.moderatorUnlock = false;
						this.getMapa(this.item_id);
					})
					.catch(error => {
						if (error) {
							console.log(error);
						}
						this.showError('Napaka pri shranjevanju mape');
						this.isLoading = false;
					});
			}
		},
		onCancelModal: function (evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(() => {
				this.clearModalData();
			}, 500);
		},
		click_showPlacila: function (button) {
			this.showPlacilaModal();
		},
		click_showModalZeljenaIzstavitevRacuna: function (button) {
			this.$refs.zeljenaIzstavitevRacunaModal.showModal(this.item_id, this.zeljenaIzstavitevRacuna);
		},
		showPlacilaModal: function () {
			this.$refs.placilaModal.showModal(
				this.item_id,
				this.prodajalec_name,
				this.kupec,
				this.ogrodje,
				this.vozilo,
				this.st_racuna,
				this.datum_racuna,
				this.skupni_znesek,
				this.prodajna_cena,
				this.nakazila,
				this.sumPovracila(),
				this.starost,
				this.datum_prodajalec_potrdil,
				this.datum_sekretar_potrdil,
				this.datum_moderator_potrdil,
				this.datum_racunovodja_potrdil,
				this.podaljsano_jamstvo_znesek,
				this.myr_znesek
			);
		},
		click_removeProdajalecPotrdil () {
			this.removeUserPotrdil(1);
		},
		click_removeSekretarPotrdil () {
			this.removeUserPotrdil(2);
		},
		click_removeModeratorPotrdil () {
			this.removeUserPotrdil(3);
		},
		click_removeRacunovodjaPotrdil () {
			this.removeUserPotrdil(4);
		},
		removeUserPotrdil (removeAkcija) {
			this.isLoading = true;
			service.mapaRemoveUserPotrdil(this.item_id, removeAkcija)
				.then(response => {
					if (response['message'] === 'success') {
						if (response['mapa']) {
							let mapa = response['mapa'];
							this.datum_prodajalec_potrdil = mapa['datum_prodajalec_potrdil'] ? parse(mapa['datum_prodajalec_potrdil'], settings.dbDtFormat) : null;
							this.datum_sekretar_potrdil = mapa['datum_sekretar_potrdil'] ? parse(mapa['datum_sekretar_potrdil'], settings.dbDtFormat) : null;
							this.datum_moderator_potrdil = mapa['datum_moderator_potrdil'] ? parse(mapa['datum_moderator_potrdil'], settings.dbDtFormat) : null;
							this.datum_racunovodja_potrdil = mapa['datum_racunovodja_potrdil'] ? parse(mapa['datum_racunovodja_potrdil'], settings.dbDtFormat) : null;
							if (this.datum_prodajalec_potrdil === null) {
								this.zeljenaIzstavitevRacuna = null;
							}
							this.isLoading = false;
						} else {
							this.showError('Napaka (strežnik ni vrnil mape)!');
							console.error('response[mapa] == null!');
							this.isLoading = false;
						}
					} else {
						this.showError('Neveljaven odziv strežnika!');
						console.error('Neveljaven response message: ' + response['message']);
						this.isLoading = false;
					}
				})
				.catch(error => {
					this.isLoading = false;
					if (error.response) {
						// Request made and server responded
						if (error.response.data.message === settings.errorMessages.serverSideValidationError) {
							this.showError('Napaka pri validaciji na strežniku!');
							console.error(error.response.data.message + ': ', error.response.data.errors);
						} else if (error.response.data.message === settings.errorMessages.notSavedError) {
							this.showError('Napaka pri shranjevanju!');
							console.error(error.response.data.message);
						} else if (error.response.data.message === 'invalidAction') {
							this.showError('Neznana akcija brisanja!');
							console.error(error.response.data.message);
						} else if (error.response.data.message === settings.errorMessages.invalidRole) {
							this.showError('Uporabnik nima pravice odstranjevanja potrditev!');
							console.error(error.response.data.message);
						} else if (error.response.data.message === settings.errorMessages.PDOException) {
							this.showError('Napaka na strežniku!');
							console.error(error.response.data.message, 'details in .ex');
						} else {
							this.showError('Neznana napaka na strežniku!');
							console.error(error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						console.log('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
		},
		click_addNakazilo: function (evt) {
			if (!this.novo_nakazilo.tip) {
				this.showError('Tip nakazila ni izbran');
				return;
			}
			var res = znasekRegex.test(this.novo_nakazilo.znesek);
			if (this.novo_nakazilo.znesek === '' || !res) {
				this.showError('Znesek nakazila ni pravilen');
				return;
			}
			this.showError(null);
			// add
			this.nakazila.push({
				id: 0 - this.nakazila.length,
				tip: this.novo_nakazilo.tip.value,
				datum: this.novo_nakazilo.datum,
				znesek: this.novo_nakazilo.znesek,
				opomba: this.novo_nakazilo.opomba,
				st_kupoprodajne_pogodbe: null,
				ujemajocPrilivId: null,
				ujemajocPrilivZnesek: null
			});
			this.novo_nakazilo.id = 0;
			this.novo_nakazilo.tip = '';
			this.novo_nakazilo.datum = null;
			this.novo_nakazilo.znesek = null;
			this.novo_nakazilo.opomba = '';
			this.novo_nakazilo.st_kupoprodajne_pogodbe = null;
			this.novo_nakazilo.ujemajocPrilivId = null;
			this.novo_nakazilo.ujemajocPrilivZnesek = null;
			this.nakazilaChange();
		},
		click_removeNakazilo: function (nakazilo, evt) {
			this.nakazila_to_delete.push(nakazilo.id);
			this.nakazila = this.nakazila.filter(function (value, index, arr) {
				return value.id !== nakazilo.id;
			});
			this.nakazilaChange();
		},
		tipNakazila_createOption: function (value) {
			let n = {
				label: value,
				value: value
			};
			return n;
		},
		click_addPovracilo: function (evt) {
			if (!this.novo_povracilo.tip) {
				this.showError('Tip povračila ni izbran');
				return;
			}
			var res = znasekRegex.test(this.novo_povracilo.znesek);
			if (this.novo_povracilo.znesek === '' || !res) {
				this.showError('Znesek povračila ni pravilen');
				return;
			}
			this.showError(null);
			// add
			this.povracila.push({
				id: 0 - this.povracila.length,
				tip: this.novo_povracilo.tip.value,
				datum: this.novo_povracilo.datum,
				znesek: this.novo_povracilo.znesek,
				ujemajocePovraciloDataId: null,
				ujemajocePovraciloDataZnesek: null
			});
			this.novo_povracilo.id = 0;
			this.novo_povracilo.tip = '';
			this.novo_povracilo.datum = null;
			this.novo_povracilo.znesek = null;
		},
		click_removePovracilo: function (povracilo, evt) {
			this.povracila_to_delete.push(povracilo.id);
			this.povracila = this.povracila.filter(function (value, index, arr) {
				return value.id !== povracilo.id;
			});
		},
		tipPovracila_createOption: function (value) {
			let n = {
				label: value,
				value: value
			};
			return n;
		},
		click_addOprema: function (evt) {
			if (!this.nova_oprema.tip) {
				this.showError('Tip opreme ni izbran');
				return;
			}
			var res = znasekRegex.test(this.nova_oprema.znesek);
			if (this.nova_oprema.znesek === '' || !res) {
				this.showError('Znesek opreme ni pravilen');
				return;
			}
			this.showError(null);
			// add
			this.oprema.push({
				id: 0 - this.oprema.length,
				tip: this.nova_oprema.tip.value,
				znesek: this.nova_oprema.znesek,
				datum_narocila: this.nova_oprema.datum_narocila,
				opomba: this.nova_oprema.opomba
			});
			this.nova_oprema.id = 0;
			this.nova_oprema.tip = '';
			this.nova_oprema.znesek = null;
			this.nova_oprema.datum_narocila = null;
			this.nova_oprema.opomba = '';
		},
		click_removeOprema: function (oprema, evt) {
			this.dodatneopreme_to_delete.push(oprema.id);
			this.oprema = this.oprema.filter(function (value, index, arr) {
				return value.id !== oprema.id;
			});
		},
		tipOpreme_createOption: function (value) {
			let n = {
				label: value,
				value: value
			};
			return n;
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		sumNakazila: function () {
			let sum = 0;
			for (let nakazilo of this.nakazila) {
				sum += nakazilo.znesek;
			}
			return sum;
		},
		sumPovracila: function () {
			let sum = 0;
			for (let povracilo of this.povracila) {
				sum += povracilo.znesek;
			}
			return sum;
		},
		on_userPotrdilSuccess: function (datum, userId, userRole, akcija) {
			this.$emit('userpotrdil-success', datum, userId, userRole, akcija);
			if (akcija === 1) {
				this.datum_prodajalec_potrdil = datum;
			} else if (akcija === 2) {
				this.datum_sekretar_potrdil = datum;
			} else if (akcija === 3) {
				this.datum_moderator_potrdil = datum;
			} else if (akcija === 4) {
				this.datum_racunovodja_potrdil = datum;
			}
			if (this.autoLoadPlacila) {
				this.$refs.modal.hide();
				this.clearModalData();
			}
		},
		on_success_zeljenaIzstavitevRacuna: function (datum) {
			if (typeof datum === 'string' && datum != null) {
				this.zeljenaIzstavitevRacuna = parse(datum, settings.dbDtFormat);
			} else {
				this.zeljenaIzstavitevRacuna = null;
			}
		},
		on_userPotrdilCanceled: function () {
			if (this.autoLoadPlacila) {
				this.$refs.modal.hide();
				this.clearModalData();
			}
		},
		clearModalData: function () {
			this.item_id = null;
			this.ogrodje = '';
			this.vozilo = '';
			this.prodajalec_id = 0;
			this.prodajalec_name = '';
			this.kupec = '';
			this.starost = 0;
			this.datum_nakupa = '';
			this.datum_planirane_dobave = '';
			this.financiranje_rci = '';
			this.koncesija_datum = '';
			this.podaljsano_jamstvo_picked = null;
			this.podaljsano_jamstvo_leta = null;
			this.podaljsano_jamstvo_km = null;
			this.podaljsano_jamstvo_znesek = null;
			this.podaljsano_jamstvo_opomba = null;
			this.zavarovanje_picked = null;
			this.zavarovanje_opomba = null;
			this.myr_picked = null;
			this.myr_leta = null;
			this.myr_km = null;
			this.myr_znesek = null;
			this.myr_opomba = null;
			this.gap_picked = null;
			this.gap_opomba = null;
			this.bni_picked = null;
			this.bni_opomba = null;
			this.bonus1 = null;
			this.bonus2 = null;
			this.bonus3 = null;
			this.bonus4 = null;
			this.bonus5 = null;
			this.bonus6 = null;
			this.ostali_dogovori = null;
			this.nulti_picked = null;
			this.ciscenje_picked = null;
			this.klic_stranke = null;
			this.st_racuna = null;
			this.datum_racuna = null;
			this.prodajna_cena = null;
			this.skupni_znesek = null;
			this.rci_lizing = null;
			this.rci_kredit = null;
			this.nakazila = [];
			this.nakazila_to_delete = [];
			this.novo_nakazilo = {
				id: 0,
				tip: '',
				znesek: null,
				datum: null,
				opomba: '',
				st_kupoprodajne_pogodbe: null,
				ujemajocPrilivId: null,
				ujemajocPrilivZnesek: null
			};
			this.povracila = [];
			this.povracila_to_delete = [];
			this.novo_povracilo = {
				id: 0,
				tip: '',
				znesek: null,
				datum: null,
				ujemajocePovraciloDataId: null,
				ujemajocePovraciloDataZnesek: null
			};
			this.oprema = [];
			this.dodatneopreme_to_delete = [];
			this.nova_oprema = {
				id: 0,
				tip: '',
				znesek: null,
				datum_narocila: null,
				opomba: ''
			};
			this.message = {
				type: null,
				text: null
			};
			this.datum_prodajalec_potrdil = null;
			this.datum_sekretar_potrdil = null;
			this.datum_moderator_potrdil = null;
			this.datum_racunovodja_potrdil = null;
			this.mapaExist = false;
			this.formChanged = false;
			this.initChangeNakazila = false;
			this.prilivi = [];
			this.prilivHover = {
				id: null,
				datum: null,
				placnik: null,
				znesek: null,
				vir: null
			}
			this.priliviBrezUjemanj = [];
			this.povracilaData = [];
			this.datoteke = [];
			this.povraciloDataHover = {
				id: null,
				creditnotedate: null,
				amount: null,
				action_name: null,
				sale_channel: null
			};
			this.povracilaDataBrezUjemanja = [];
			this.nakazilaPrilivPar = {
				nakazilo: null,
				priliv: null
			};
			this.nakazilaPriliviPari = [];
			this.zeljenaIzstavitevRacuna = null;
			this.datum_izstavitve_racuna = null;
			this.gumbPlaciloTitle = '';
			this.gumbZeljeniRacunTitle = '';
			this.moderatorUnlock = false;
		},
		najdiUjemanjaNakazil: function () {
			let nakazilaTmp = [];
			let priliviTmp = [];
			for (let nakazilo of this.nakazila) {
				if (nakazilo.tip === 'Rabljeno vozilo') {
					nakazilaTmp.push(nakazilo);
					nakazilo.ujemajocPrilivId = 0 - this.nakazila.length;
					nakazilo.ujemajocPrilivZnesek = nakazilo.znesek;
					this.nakazila = this.nakazila.filter(function (value, index, arr) {
						return value.id !== nakazilo.id;
					});
				} else {
					for (let priliv of this.priliviBrezUjemanj) {
						if (nakazilo.znesek === Number(priliv.znesek)) {
							nakazilaTmp.push(nakazilo);
							this.nakazila = this.nakazila.filter(function (value, index, arr) {
								return value.id !== nakazilo.id;
							});
							this.priliviBrezUjemanj = this.priliviBrezUjemanj.filter(function (value, index, arr) {
								return value.id !== priliv.id;
							});
							nakazilo.ujemajocPrilivId = priliv.id;
							nakazilo.ujemajocPrilivZnesek = Number(priliv.znesek);
							break;
						}
					}
				}
			}
			for (let nakazilo of this.nakazila) {
				nakazilaTmp.push(nakazilo);
			}
			for (let priliv of this.priliviBrezUjemanj) {
				priliv.znesek = Number(priliv.znesek);
				priliviTmp.push(priliv);
			}
			this.nakazila = nakazilaTmp;
			this.priliviBrezUjemanj = priliviTmp;
		},
		clickPrilivZnesek: function (idPriliva, evt) {
			var izbranPriliv = this.prilivi.find(priliv => {
				return priliv.id === idPriliva;
			})
			this.$refs.editPrilivModal.showModal(izbranPriliv, true);
		},
		getPrilivInfo (idPriliva) {
			var izbranPriliv = this.prilivi.find(priliv => {
				return priliv.id === idPriliva;
			})
			this.prilivHover.id = izbranPriliv.id;
			this.prilivHover.datum = izbranPriliv.datum;
			this.prilivHover.placnik = izbranPriliv.placnik;
			this.prilivHover.znesek = izbranPriliv.znesek;
			this.prilivHover.vir = izbranPriliv.vir;
		},
		resetPrilivInfo () {
			this.prilivHover.id = null;
			this.prilivHover.datum = null;
			this.prilivHover.placnik = null;
			this.prilivHover.znesek = null;
			this.prilivHover.vir = null;
		},
		najdiUjemanjaPovracil: function () {
			let povracilaTmp = [];
			let povracilaDataTmp = [];
			for (let povracilo of this.povracila) {
				for (let povraciloData of this.povracilaDataBrezUjemanja) {
					if (povracilo.znesek === Number(this.dodajDavek(povraciloData.amount).toFixed(2))) {
						povracilaTmp.push(povracilo);
						this.povracila = this.povracila.filter(function (value, index, arr) {
							return value.id !== povracilo.id;
						});
						this.povracilaDataBrezUjemanja = this.povracilaDataBrezUjemanja.filter(function (value, index, arr) {
							return value.id !== povraciloData.id;
						});
						povracilo.ujemajocePovraciloDataId = povraciloData.id;
						povracilo.ujemajocePovraciloDataZnesek = Number(this.dodajDavek(povraciloData.amount));
						break;
					}
				}
			}
			for (let povracilo of this.povracila) {
				povracilaTmp.push(povracilo);
			}
			for (let povraciloData of this.povracilaDataBrezUjemanja) {
				povraciloData.amount = Number(this.dodajDavek(povraciloData.amount));
				povracilaDataTmp.push(povraciloData);
			}
			this.povracila = povracilaTmp;
			this.povracilaDataBrezUjemanja = povracilaDataTmp;
		},
		getPovraciloDataInfo (idPovracilaData) {
			var izbranoPovracilo = this.povracilaData.find(povraciloData => {
				return povraciloData.id === idPovracilaData;
			})
			this.povraciloDataHover.id = izbranoPovracilo.id;
			this.povraciloDataHover.creditnotedate = izbranoPovracilo.creditnotedate;
			this.povraciloDataHover.amount = izbranoPovracilo.amount;
			this.povraciloDataHover.action_name = izbranoPovracilo.action_name;
			this.povraciloDataHover.sale_channel = izbranoPovracilo.sale_channel;
		},
		resetPovraciloDataInfo () {
			this.povraciloDataHover.id = null;
			this.povraciloDataHover.creditnotedata = null;
			this.povraciloDataHover.amount = null;
			this.povraciloDataHover.action_name = null;
			this.povraciloDataHover.sale_channel = null;
		},
		naloziDatoteko_click () {
			this.$refs.naloziDatotekoModal.showModal('mapa', this.item_id);
		},
		onNaloziDatoteko_success: function (result) {
			result = this.addFilesTypes(result);
			for (let datoteka of result) {
				this.datoteke.push(datoteka);
			}
		},
		removeDatoteka_click: function (item) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati datoteko ' + item.ime_datoteke + '?', {
				title: 'Potrdite brisanje datoteke',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					service.removeFileOfMapa(item.id)
						.then(response => {
							this.datoteke = this.datoteke.filter(function (value, index, arr) {
								return value.id !== item.id;
							});
							this.showError(null);
							this.$refs.datotekeTable.refresh();
						})
						.catch(error => {
							this.showError('Napaka odstranjevanju datoteke!');
							if (error) {
								console.log(error);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		},
		downloadDatoteka_click: function (item) {
			service.downloadFileOfMapa(item.id)
				.then(response => {
					console.log(response);
					let blob = new Blob([response.data], { type: response.headers['content-type'] })
					let link = document.createElement('a')
					link.href = window.URL.createObjectURL(blob)
					link.download = item.ime_datoteke;
					link.click()
					this.showError(null);
				})
				.catch(error => {
					this.showError('Napaka pri prenosu datoteke!');
					if (error) {
						console.log(error);
					}
				});
		},
		dodajDavek: function (znesek) {
			return +znesek + (+znesek * (this.stopnja_ddv / 100));
		},
		click_setKupoprodajnaPogodba: function (nakazilo, evt) {
			let tmpNakazilo = {
				id: nakazilo.id,
				st_kupoprodajne_pogodbe: nakazilo.st_kupoprodajne_pogodbe
			};
			this.$refs.dodajanjeStKupoprodajnePogodbeModal.showModal(tmpNakazilo);
		},
		on_success_stKupoprodajnePogodbe: function (nakaziloId, stKupoprodajnePogodbe) {
			let nakazilo = this.nakazila.find(nakazilo => {
				return nakazilo.id === nakaziloId;
			});
			nakazilo.st_kupoprodajne_pogodbe = stKupoprodajnePogodbe;
		},
		getKupoprodajnaPogodbaTitle: function (nakazilo) {
			if (nakazilo.id < 1) {
				return 'Najprej je potrebno shraniti mapo';
			} else {
				return nakazilo.st_kupoprodajne_pogodbe;
			}
		},
		getRabljenoVoziloInfo (nakazilo) {
			return 'Št. kupoprodajne pogodbe: ' + nakazilo.st_kupoprodajne_pogodbe;
		},
		nakazilaChange: function () {
			if (this.initChangeNakazila) {
				this.formChanged = true;
			}
		}
	},
	data: function () {
		return {
			isLoading: false,
			fullPage: true,
			item_id: null,
			autoLoadPlacila: false,
			ogrodje: '',
			vozilo: '',
			prodajalec_id: 0,
			prodajalec_name: '',
			kupec: '',
			starost: 0,
			datum_nakupa: '',
			datum_planirane_dobave: '',
			financiranje_rci: '',
			koncesija_datum: '',
			podaljsano_jamstvo_picked: null,
			podaljsano_jamstvo_leta: null,
			podaljsano_jamstvo_km: null,
			podaljsano_jamstvo_znesek: null,
			podaljsano_jamstvo_opomba: null,
			zavarovanje_picked: null,
			zavarovanje_opomba: null,
			myr_picked: null,
			myr_leta: null,
			myr_km: null,
			myr_znesek: null,
			myr_opomba: null,
			gap_picked: null,
			gap_opomba: null,
			bni_picked: null,
			bni_opomba: null,
			bonus1: null,
			bonus2: null,
			bonus3: null,
			bonus4: null,
			bonus5: null,
			bonus6: null,
			ostali_dogovori: null,
			nulti_picked: null,
			ciscenje_picked: null,
			klic_stranke: null,
			st_racuna: null,
			datum_racuna: null,
			prodajna_cena: null,
			skupni_znesek: null,
			rci_lizing: null,
			rci_kredit: null,
			nakazila: [],
			nakazila_to_delete: [],
			novo_nakazilo: {
				id: 0,
				tip: '',
				znesek: null,
				datum: null,
				opomba: '',
				st_kupoprodajne_pogodbe: ''
			},
			tipi_nakazil: [
				{
					label: 'Placilo stranke',
					value: 'Placilo stranke'
				},
				{
					label: 'Ara',
					value: 'Ara'
				},
				{
					label: 'Blagajna',
					value: 'Blagajna'
				},
				{
					label: 'Nakazilo',
					value: 'Nakazilo'
				},
				{
					label: 'Banka',
					value: 'Banka'
				},
				{
					label: 'Rabljeno vozilo',
					value: 'Rabljeno vozilo'
				},
				{
					label: 'RCI Lizing',
					value: 'RCI Lizing'
				},
				{
					label: 'RCI Kredit',
					value: 'RCI Lizing'
				}
			],
			povracila: [],
			povracila_to_delete: [],
			novo_povracilo: {
				id: 0,
				tip: '',
				znesek: null,
				datum: null
			},
			tipi_povracil: [
				{
					label: 'End of life',
					value: 'End of life'
				},
				{
					label: 'Zimske gume',
					value: 'Zimske gume'
				},
				{
					label: 'Lista šasij',
					value: 'Lista šasij'
				},
				{
					label: 'Redna akcija',
					value: 'Redna akcija'
				},
				{
					label: 'Dodatno odobren popust',
					value: 'Dodatno odobren popust'
				},
				{
					label: 'Staro za novo',
					value: 'Staro za novo'
				},
				{
					label: 'Cash plan RCI',
					value: 'Cash plan RCI'
				}
			],
			oprema: [],
			dodatneopreme_to_delete: [],
			nova_oprema: {
				id: 0,
				tip: '',
				znesek: null,
				datum_narocila: null,
				opomba: ''
			},
			tipi_opreme: [
				{
					label: 'Strešni nosilci',
					value: 'Strešni nosilci'
				},
				{
					label: 'Gume',
					value: 'Gume'
				},
				{
					label: 'Parkirni senzorji',
					value: 'Parkirni senzorji'
				},
				{
					label: 'Predelava',
					value: 'Predelava'
				},
				{
					label: 'Obvezna oprema',
					value: 'Obvezna oprema'
				}
			],
			message: {
				type: null,
				text: null
			},
			ACTION_TYPE_ERROR: 'ERROR',
			datum_prodajalec_potrdil: null,
			datum_sekretar_potrdil: null,
			datum_moderator_potrdil: null,
			datum_racunovodja_potrdil: null,
			mapaExist: false,
			formChanged: false,
			initChangeNakazila: false,
			prilivi: [],
			prilivHover: {
				id: null,
				datum: null,
				placnik: null,
				znesek: null,
				vir: null
			},
			povraciloDataHover: {
				id: null,
				creditnotedate: null,
				amount: null,
				action_name: null,
				sale_channel: null
			},
			priliviBrezUjemanj: [],
			povracilaData: [],
			povracilaDataBrezUjemanja: [],
			datoteke: [],
			datotekeTable_fields: [
				{ key: 'file_type', label: '', class: 'tdIcons' },
				{ key: 'ime_datoteke', label: 'Ime', sortable: false },
				{ key: 'actions', label: '', sortable: false, class: 'tdActions' }
			],
			zeljenaIzstavitevRacuna: null,
			datum_izstavitve_racuna: null,
			stopnja_ddv: null,
			gumbPlaciloTitle: '',
			gumbZeljeniRacunTitle: '',
			moderatorUnlock: false
		}
	},
	watch: {
		prodajna_cena: function (val, Oldval) {
			if (!(val && !Oldval) && this.item_id) {
				this.formChanged = true;
			}
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		isRoleProdajalec () {
			return settings.isProdajalec(this.user.role);
		},
		isRoleSekretar () {
			return settings.isSekretar(this.user.role);
		},
		isRoleRacunovodja () {
			return settings.isRacunovodja(this.user.role);
		},
		isRoleModerator () {
			return settings.isModerator(this.user.role);
		},
		isRoleAdmin () {
			return settings.isAdmin(this.user.role);
		},
		placiloDisabled () {
			if (!this.mapaExist) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (mapa še ni shranjena)';
				return true;
			} if (this.formChanged) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (Prodajna cena ali nakazila so se spremenila, najprej shranite mapo)';
				return true;
			} if (!this.prodajna_cena) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (Prodajna cena ni vnešena)';
				return true;
			} if (this.prodajna_cena <= 0) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (Prodajna cena mora biti večja od 0€)';
				return true;
			} if (Math.abs(this.razlika) > 100) {
				this.gumbPlaciloTitle = 'Plačilo onemogočeno (Razlika med nakazili in prodajno ceno je večja od 100€)';
				return true;
			}
			this.gumbPlaciloTitle = 'Plačilo omogočeno';
			return false;
		},
		zeljenaIzstavitevRacunaShow () {
			if (this.isProdajalecPotrdil) {
				return true;
			}
			return false;
		},
		zeljenaIzstavitevRacunaDisabled () {
			if (this.datum_izstavitve_racuna) {
				this.gumbZeljeniRacunTitle = 'Račun je že bil izstavljen.';
				return true;
			}
			this.gumbZeljeniRacunTitle = '';
			return false;
		},
		modalDisabled () {
			/*
			if (this.isRoleProdajalec) {
				if (this.isProdajalecPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleSekretar) {
				if (this.isSekretarPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleModerator) {
				if (this.isModeratorPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleRacunovodja) {
				if (this.isRacunovodjaPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleAdmin) {
				if (this.isRacunovodjaPotrdil) {
					return true;
				} else {
					return false;
				}
			} */
			return false;
		},
		tabFinanceDisabled () {
			if (this.showLockIcon && this.moderatorUnlock) {
				return false;
			}
			if (this.isRoleProdajalec) {
				if (this.isProdajalecPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleSekretar) {
				if (this.isSekretarPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleModerator) {
				if (this.isModeratorPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleRacunovodja) {
				if (this.isRacunovodjaPotrdil) {
					return true;
				} else {
					return false;
				}
			} else if (this.isRoleAdmin) {
				if (this.isRacunovodjaPotrdil) {
					return true;
				} else {
					return false;
				}
			}
			return false;
		},
		showLockIcon () {
			if (this.isRoleModerator) {
				if (this.isProdajalecPotrdil && this.isSekretarPotrdil && this.isModeratorPotrdil && this.isRacunovodjaPotrdil) {
					return true;
				} else {
					return false;
				}
			}
			return false;
		},
		isProdajalecPotrdil () {
			if (this.datum_prodajalec_potrdil && this.datum_prodajalec_potrdil !== '' && this.datum_prodajalec_potrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isSekretarPotrdil () {
			if (this.datum_sekretar_potrdil && this.datum_sekretar_potrdil !== '' && this.datum_sekretar_potrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isModeratorPotrdil () {
			if (this.datum_moderator_potrdil && this.datum_moderator_potrdil !== '' && this.datum_moderator_potrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		isRacunovodjaPotrdil () {
			if (this.datum_racunovodja_potrdil && this.datum_racunovodja_potrdil !== '' && this.datum_racunovodja_potrdil !== 'DD. MM. YYYY') {
				return true;
			} else {
				return false;
			}
		},
		razlika () {
			let pCena = this.prodajna_cena;
			let nak = this.sumNakazila();
			return nak - pCena;
		},
		priliviSkupaj () {
			let skupaj = 0;
			for (let priliv of this.prilivi) {
				skupaj = +skupaj + +priliv.znesek;
			}
			return this.moneyFormatter.format(skupaj);
		},
		povracilaDataSkupaj () {
			let skupaj = 0.0;
			for (let povraciloData of this.povracilaData) {
				skupaj = +skupaj + +povraciloData.amount;
			}
			return this.moneyFormatter.format(this.dodajDavek(skupaj));
		},
		razlikaFormatted () {
			return this.moneyFormatter.format(this.razlika);
		},
		razlikaClass () {
			return {
				positive: this.razlika > 0,
				negative: this.razlika < 0,
				input_total: true
			};
		},
		sestevekPovracila () {
			return this.sumPovracila();
		},
		sestevekPovracilaFormatted () {
			return this.moneyFormatter.format(this.sestevekPovracila);
		},
		sestevekPovracilaClass () {
			return {
				positive: this.sestevekPovracila > 0,
				negative: this.sestevekPovracila < 0,
				input_total: true
			};
		}
	},
	created () {
	}
}
</script>
<template>
	<div>
		<b-modal no-close-on-backdrop ref="modal" title="Mapa vozila" class="modal-primary" size="xl" @hidden="clearModalData">
			<loading :active.sync="isLoading"></loading>
			<b-tabs>
				<b-tab title="Podrobnosti" active>
					<b-row>
						<b-col>
							<b-form-group label="Šasija:">
								<b-form-input type="text" v-model="ogrodje" disabled></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Datum nakupa:">
								<b-form-input type="text" :value="datum_nakupa | hr_date" disabled></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Datum planirane dobave:">
								<b-form-input type="text" :value="datum_planirane_dobave | hr_date" disabled></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Datum koncesije:">
								<b-form-input type="text" :value="koncesija_datum | hr_date" disabled></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col cols="3" class="l_znesek">Financiranje RCI:</b-col>
						<b-col>
							<b-form-radio-group v-model="financiranje_rci" class="rb_DaNe" disabled>
								<b-form-radio value="1">Da</b-form-radio>
								<b-form-radio value="0">Ne</b-form-radio>
							</b-form-radio-group>
						</b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col class="l_znesek">RCI Lizing (št. pogodbe):</b-col>
						<b-col><b-form-input v-model="rci_lizing" type="text" :disabled="modalDisabled"></b-form-input></b-col>
						<b-col class="l_znesek">RCI Kredit (št. pogodbe):</b-col>
						<b-col><b-form-input v-model="rci_kredit" type="text" :disabled="modalDisabled"></b-form-input></b-col>
					</b-row>
					<b-row style="margin-top:10px;">
						<b-col cols="2"></b-col>
						<b-col cols="3"></b-col>
						<b-col>Leta</b-col>
						<b-col>KM</b-col>
						<b-col>Znesek</b-col>
						<b-col>Opomba</b-col>
					</b-row>
					<b-row>
						<b-col cols="2" class="l_znesek">Pod. jamstvo:</b-col>
						<b-col cols="3">
							<b-form-radio-group v-model="podaljsano_jamstvo_picked" class="rb_DaNe" :disabled="modalDisabled">
								<b-form-radio value="1">Da</b-form-radio>
								<b-form-radio value="0">Ne</b-form-radio>
							</b-form-radio-group>
						</b-col>
						<b-col><b-form-input v-model="podaljsano_jamstvo_leta" type="text" :disabled="modalDisabled"></b-form-input></b-col>
						<b-col><b-form-input v-model="podaljsano_jamstvo_km" type="text" :disabled="modalDisabled"></b-form-input></b-col>
						<b-col><currency-input v-model="podaljsano_jamstvo_znesek" class="form-control" :disabled="modalDisabled"></currency-input></b-col>
						<b-col><b-form-input v-model="podaljsano_jamstvo_opomba" type="text" :disabled="modalDisabled"></b-form-input></b-col>
					</b-row>
					<b-row style="margin-top:5px;">
						<b-col cols="2" class="l_znesek">MYR.:</b-col>
						<b-col cols="3">
							<b-form-radio-group v-model="myr_picked" class="rb_DaNe" :disabled="modalDisabled">
								<b-form-radio value="1">Da</b-form-radio>
								<b-form-radio value="0">Ne</b-form-radio>
							</b-form-radio-group>
						</b-col>
						<b-col><b-form-input v-model="myr_leta" type="text" :disabled="modalDisabled"></b-form-input></b-col>
						<b-col><b-form-input v-model="myr_km" type="text" :disabled="modalDisabled"></b-form-input></b-col>
						<b-col><currency-input v-model="myr_znesek" class="form-control" :disabled="modalDisabled"></currency-input></b-col>
						<b-col><b-form-input v-model="myr_opomba" type="text" :disabled="modalDisabled"></b-form-input></b-col>
					</b-row>
					<b-row style="margin-top:10px;">
						<b-col cols="5"></b-col>
						<b-col cols="7">Opomba</b-col>
					</b-row>
					<b-row style="margin-top:5px;">
						<b-col cols="2" class="l_znesek">Zavarovanje:</b-col>
						<b-col cols="3">
							<b-form-radio-group v-model="zavarovanje_picked" class="rb_DaNe" :disabled="modalDisabled">
								<b-form-radio value="1">Da</b-form-radio>
								<b-form-radio value="0">Ne</b-form-radio>
							</b-form-radio-group>
						</b-col>
						<b-col cols="7"><b-form-input v-model="zavarovanje_opomba" type="text" :disabled="modalDisabled"></b-form-input></b-col>
					</b-row>
					<b-row style="margin-top:5px;">
						<b-col cols="2" class="l_znesek">GAP:</b-col>
						<b-col cols="3">
							<b-form-radio-group v-model="gap_picked" class="rb_DaNe" :disabled="modalDisabled">
								<b-form-radio value="1">Da</b-form-radio>
								<b-form-radio value="0">Ne</b-form-radio>
							</b-form-radio-group>
						</b-col>
						<b-col cols="7"><b-form-input v-model="gap_opomba" type="text" :disabled="modalDisabled"></b-form-input></b-col>
					</b-row>
					<b-row style="margin-top:5px;">
						<b-col cols="2" class="l_znesek">BNI:</b-col>
						<b-col cols="3">
							<b-form-radio-group v-model="bni_picked" class="rb_DaNe" :disabled="modalDisabled">
								<b-form-radio value="1">Da</b-form-radio>
								<b-form-radio value="0">Ne</b-form-radio>
							</b-form-radio-group>
						</b-col>
						<b-col cols="7"><b-form-input v-model="bni_opomba" type="text" :disabled="modalDisabled"></b-form-input></b-col>
					</b-row>
					<b-row style="margin-top:5px;">
						<b-col cols="2" class="l_znesek">Nulti servis:</b-col>
						<b-col cols="3">
							<b-form-radio-group v-model="nulti_picked" class="rb_DaNe" :disabled="modalDisabled">
								<b-form-radio value="1">Da</b-form-radio>
								<b-form-radio value="0">Ne</b-form-radio>
							</b-form-radio-group>
						</b-col>
						<b-col cols="2" class="l_znesek">Čiščenje:</b-col>
						<b-col cols="3">
							<b-form-radio-group v-model="ciscenje_picked" class="rb_DaNe" :disabled="modalDisabled">
								<b-form-radio value="1">Da</b-form-radio>
								<b-form-radio value="0">Ne</b-form-radio>
							</b-form-radio-group>
						</b-col>
						<b-col cols="2"></b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col class="l_znesek">Klic stranke:</b-col>
						<b-col cols="9"><b-form-input v-model="klic_stranke" type="text" :disabled="modalDisabled"></b-form-input></b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col cols="3" class="l_znesek">Ostali dogovori:</b-col>
						<b-col cols="9"><b-form-input v-model="ostali_dogovori" type="text" :disabled="modalDisabled"></b-form-input></b-col>
					</b-row>
					<b-row style="margin-top:10px;">
						<b-col class="b_removePotrdil" align-self="center">
							<b-form-group v-if="isProdajalecPotrdil" label="Prodajalec potrdil:">
								<b-row>
									<b-col cols="10">
										<b-form-input :value="datum_prodajalec_potrdil | hr_date" type="text" disabled></b-form-input>
									</b-col>
									<b-col cols="2">
										<b-button v-if="(isRoleModerator || isRoleAdmin) && isProdajalecPotrdil" @click.stop="click_removeProdajalecPotrdil()" class="b_iconaction">
											<i class="fa fa-remove"></i>
										</b-button>
									</b-col>
								</b-row>
							</b-form-group>
						</b-col>
						<b-col class="b_removePotrdil" align-self="center">
							<b-form-group v-if="isProdajalecPotrdil" label="Sekretar potrdil:">
								<b-row>
									<b-col cols="10">
										<b-form-input :value="datum_sekretar_potrdil | hr_date" type="text" disabled></b-form-input>
									</b-col>
									<b-col cols="2">
										<b-button v-if="(isRoleModerator || isRoleAdmin) && isProdajalecPotrdil && isSekretarPotrdil" @click.stop="click_removeSekretarPotrdil()" class="b_iconaction">
											<i class="fa fa-remove"></i>
										</b-button>
									</b-col>
								</b-row>
							</b-form-group>
						</b-col>
						<b-col class="b_removePotrdil" align-self="center">
							<b-form-group v-if="isProdajalecPotrdil" label="Moderator potrdil:">
								<b-row>
									<b-col cols="10">
										<b-form-input :value="datum_moderator_potrdil | hr_date" type="text" disabled></b-form-input>
									</b-col>
									<b-col cols="2">
										<b-button v-if="(isRoleModerator || isRoleAdmin) && isProdajalecPotrdil && isSekretarPotrdil && isModeratorPotrdil" @click.stop="click_removeModeratorPotrdil()" class="b_iconaction">
											<i class="fa fa-remove"></i>
										</b-button>
									</b-col>
								</b-row>
							</b-form-group>
						</b-col>
						<b-col class="b_removePotrdil" align-self="center">
							<b-form-group v-if="isProdajalecPotrdil" label="Računovodja potrdil:">
								<b-row>
									<b-col cols="10">
										<b-form-input :value="datum_racunovodja_potrdil | hr_date" type="text" disabled></b-form-input>
									</b-col>
									<b-col cols="2">
										<b-button v-if="(isRoleModerator || isRoleAdmin) && isProdajalecPotrdil && isSekretarPotrdil && isModeratorPotrdil && isRacunovodjaPotrdil" @click.stop="click_removeRacunovodjaPotrdil()" class="b_iconaction">
											<i class="fa fa-remove"></i>
										</b-button>
									</b-col>
								</b-row>
							</b-form-group>
						</b-col>
					</b-row>
				</b-tab>
				<b-tab title="Finance">
					<b-row>
						<b-col>
							<h5 class="placila_sekcija">Račun RNS</h5>
						</b-col>
						<b-col class="cUpdate" cols="1">
							<div v-if="showLockIcon" @click.stop="click_toggleLock($event)" :title="moderatorUnlock ? 'Zakleni obrazec' : 'Odkleni obrazec'">
								<i v-if="!moderatorUnlock" class="fa fa-lock lockIcon"></i>
								<i v-if="moderatorUnlock" class="fa fa-unlock lockIcon"></i>
							</div>
						</b-col>
						<b-col class="cUpdate" cols="1">
							<b-button v-if="!isRoleProdajalec" ref="aUpdate" data-style="zoom-in" size="sm" title="Pridobi podatke iz M-Files" @click.stop="click_updateData($event)">
								<i class="fa fa-file ladda-label"></i>
							</b-button>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="3">
							<b-form-group label="Št. računa:">
								<b-form-input type="text" v-model="st_racuna" :disabled="modalDisabled || tabFinanceDisabled"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group label="Datum:" label-for="datum_racuna">
							<b-form-input v-if="modalDisabled || tabFinanceDisabled"  type="text" :value="datum_racuna | hr_date" disabled></b-form-input>
								<v-date-picker v-else
									ref="datumRacuna"
									id="datum_racuna"
									v-model="datum_racuna"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group v-if="!isRoleProdajalec" label="Znesek:">
								<currency-input v-model="skupni_znesek" class="form-control" :disabled="modalDisabled || tabFinanceDisabled" />
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group label="Prodajna cena:">
								<currency-input v-model="prodajna_cena" class="form-control" :disabled="modalDisabled || tabFinanceDisabled" />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col><h5 class="placila_sekcija">Nakazila</h5></b-col>
					</b-row>
					<b-row v-if="modalDisabled || tabFinanceDisabled">
					</b-row>
					<b-row v-else>
						<b-col cols="2">
							<b-form-group>
								<label>Tip:</label>
								<v-select ref="tipNakazila"
									v-model="novo_nakazilo.tip"
									:options="tipi_nakazil"
									:create-option="tipNakazila_createOption"
									:taggable="true"
									:filterable="false"
									placeholder="Izberi tip ...">
									<template slot="option" slot-scope="option">
										{{ option.label }}
									</template>
									<template slot="selected-option" slot-scope="option">
										{{ option.label }}
									</template>
								</v-select>
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group label="Opomba:">
								<b-form-input v-model="novo_nakazilo.opomba" class="form-control" />
							</b-form-group>
						</b-col>
						<b-col cols="2">
							<b-form-group label="Datum:" label-for="datum_placila">
								<v-date-picker
									ref="datumPlacila"
									id="datum_placila"
									v-model="novo_nakazilo.datum"
									:max-date="new Date(Date.now())"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col cols="2">
							<b-form-group label="Znesek:">
								<currency-input v-model="novo_nakazilo.znesek" class="form-control" :disabled="modalDisabled || tabFinanceDisabled" />
							</b-form-group>
						</b-col>
						<b-col cols="1">
							<b-button @click.stop="click_addNakazilo($event.target)" class="b_akcija b_iconaction" size="sm">
								<i class="fa fa-plus"></i>
							</b-button>
						</b-col>
						<b-col cols="2">
							<b-form-group label="Kontrola:">
							</b-form-group>
						</b-col>
					</b-row>
					<b-row v-for="nakazilo in nakazila" v-bind:key="'nakazilo-' + nakazilo.id" class="r_placilo">
						<b-col cols="2">
							<b-input-group>
								<b-form-input @input="nakazilaChange" type="text" v-model="nakazilo.tip" :disabled="modalDisabled|| tabFinanceDisabled"></b-form-input>
								<b-input-group-append v-if="nakazilo.tip === 'Rabljeno vozilo'" >
									<b-input-group-text class="p-0">
										<b-button :disabled="nakazilo.id < 1 || modalDisabled || tabFinanceDisabled" :title="getKupoprodajnaPogodbaTitle(nakazilo)" @click.stop="click_setKupoprodajnaPogodba(nakazilo, $event.target)" size="sm" class="p-0">
											<i class="fa fa-pencil buttonKupoprodajnaPogodba"></i>
										</b-button>
									</b-input-group-text>
								</b-input-group-append>
							</b-input-group>
						</b-col>
						<b-col cols="3">
							<b-form-input @input="nakazilaChange" v-model="nakazilo.opomba" class="form-control" :disabled="modalDisabled || tabFinanceDisabled" />
						</b-col>
						<b-col cols="2">
							<b-form-input v-if="modalDisabled || tabFinanceDisabled" :value="nakazilo.datum | hr_date" type="text" disabled></b-form-input>
							<v-date-picker v-else
								@input="nakazilaChange"
								v-model="nakazilo.datum"
								:max-date="new Date(Date.now())"
								:input-props='{
									class: "form-control dt_border gdt_border",
									placeholder: "DD. MM. YYYY"
								}'
								mode="single"
								locale="sl-SI" />
						</b-col>
						<b-col cols="2">
							<currency-input @input="nakazilaChange" v-model="nakazilo.znesek" class="form-control" :disabled="modalDisabled || tabFinanceDisabled" />
						</b-col>
						<b-col cols="1">
							<b-button @click.stop="click_removeNakazilo(nakazilo, $event.target)" :disabled="modalDisabled || tabFinanceDisabled" class="b_iconaction" size="sm">
								<i class="fa fa-remove"></i>
							</b-button>
						</b-col>
						<b-col cols="2">
							<div v-if="nakazilo.ujemajocPrilivId != null && nakazilo.ujemajocPrilivId > 0" v-bind:id="'tooltip-priliv-' + nakazilo.ujemajocPrilivId"  @mouseover="getPrilivInfo(nakazilo.ujemajocPrilivId)">
								<currency-input v-model="nakazilo.ujemajocPrilivZnesek" class="form-control prilivZnesek" disabled />
							</div>
							<div v-if="nakazilo.ujemajocPrilivId < 0" v-bind:id="'tooltip-priliv-' + nakazilo.ujemajocPrilivId">
								<currency-input v-if="nakazilo.st_kupoprodajne_pogodbe != '' && nakazilo.st_kupoprodajne_pogodbe != null" v-model="nakazilo.ujemajocPrilivZnesek" class="form-control prilivZnesek" disabled />
								<currency-input v-else v-model="nakazilo.ujemajocPrilivZnesek" class="form-control prilivZnesekBrezUjemanja" disabled />
							</div>
							<b-tooltip v-bind:target="'tooltip-priliv-' + nakazilo.ujemajocPrilivId" triggers="hover">
								<div v-if="nakazilo.ujemajocPrilivId < 0">
									<div v-if="nakazilo.st_kupoprodajne_pogodbe != '' && nakazilo.st_kupoprodajne_pogodbe != null">
										Št. kupoprodajne <br>
										pogodbe: <b>{{ nakazilo.st_kupoprodajne_pogodbe }}</b>
									</div>
									<div v-else>
										Št. kupoprodajne <br>
										pogodbe še ni vnesena
									</div>
								</div>
								<div v-else>
									Datum: <b>{{ prilivHover.datum | hr_date }}</b> <br>
									Plačnik: <b>{{ prilivHover.placnik }}</b> <br>
									Znesek: <b>{{ prilivHover.znesek | hr_money}} </b> <br>
									Vir: <b>{{ prilivHover.vir }}</b>
								</div>
							</b-tooltip>
						</b-col>
					</b-row>
					<b-row v-for="prilivBrezUjemanja in priliviBrezUjemanj" v-bind:key="'prilivBrezUjemanja-' + prilivBrezUjemanja.id" class="r_placilo">
						<b-col cols="10">
						</b-col>
						<b-col cols="2">
							<div v-bind:id="'tooltip-prilivBrezUjemanja-' + prilivBrezUjemanja.id"  @mouseover="getPrilivInfo(prilivBrezUjemanja.id)">
								<currency-input v-model="prilivBrezUjemanja.znesek" class="form-control prilivZnesekBrezUjemanja" disabled />
							</div>
							<b-tooltip v-bind:target="'tooltip-prilivBrezUjemanja-' + prilivBrezUjemanja.id" triggers="hover">
								Datum: <b>{{ prilivHover.datum | hr_date }}</b> <br>
								Plačnik: <b>{{ prilivHover.placnik }}</b> <br>
								Znesek: <b>{{ prilivHover.znesek  | hr_money }}</b> <br>
								Vir: <b>{{ prilivHover.vir }}</b>
							</b-tooltip>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="7"><h5 class="placila_sekcija">Razlika:</h5></b-col>
						<b-col cols="2" class="l_izracun">
							<b-form-input type="text" v-model="razlikaFormatted" disabled :class="razlikaClass"></b-form-input>
						</b-col>
						<b-col cols="1"/>
						<b-col cols="2" class="l_izracun">
							<b-form-input type="text" v-model="priliviSkupaj" disabled class="input_total"></b-form-input>
						</b-col>
					</b-row>
					<b-row>
						<b-col><h5 class="placila_sekcija">Povračila</h5></b-col>
					</b-row>
					<b-row v-if="modalDisabled || tabFinanceDisabled">
					</b-row>
					<b-row v-else>
						<b-col cols="4">
							<b-form-group>
								<label>Tip:</label>
								<v-select ref="tipPovracila"
									v-model="novo_povracilo.tip"
									:options="tipi_povracil"
									:create-option="tipPovracila_createOption"
									:taggable="true"
									:filterable="false"
									placeholder="Izberi tip ...">
									<template slot="option" slot-scope="option">
										{{ option.label }}
									</template>
									<template slot="selected-option" slot-scope="option">
										{{ option.label }}
									</template>
								</v-select>
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group label="Datum:" label-for="datum_povracila">
								<v-date-picker
									ref="datumPovracila"
									id="datum_povracila"
									v-model="novo_povracilo.datum"
									:max-date="new Date(Date.now())"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col cols="2">
							<b-form-group label="Znesek:">
								<currency-input v-model="novo_povracilo.znesek" class="form-control" />
							</b-form-group>
						</b-col>
						<b-col cols="1">
							<b-button @click.stop="click_addPovracilo($event.target)" class="b_akcija b_iconaction" size="sm">
								<i class="fa fa-plus"></i>
							</b-button>
						</b-col>
						<b-col cols="2">
							<b-form-group label="Kontrola:">
							</b-form-group>
						</b-col>
					</b-row>
					<b-row v-for="povracilo in povracila" v-bind:key="'povracilo-' + povracilo.id" class="r_placilo">
						<b-col cols="4">
							<b-form-input type="text" v-model="povracilo.tip" :disabled="modalDisabled || tabFinanceDisabled"></b-form-input>
						</b-col>
						<b-col cols="3">
							<b-form-input v-if="modalDisabled || tabFinanceDisabled" :value="povracilo.datum | hr_date" type="text" disabled></b-form-input>
							<v-date-picker v-else
								v-model="povracilo.datum"
								:max-date="new Date(Date.now())"
								:input-props='{
									class: "form-control dt_border gdt_border",
									placeholder: "DD. MM. YYYY"
								}'
								mode="single"
								locale="sl-SI" />
						</b-col>
						<b-col cols="2">
							<currency-input v-model="povracilo.znesek" class="form-control" :disabled="modalDisabled || tabFinanceDisabled" />
						</b-col>
						<b-col cols="1">
							<b-button @click.stop="click_removePovracilo(povracilo, $event.target)" :disabled="modalDisabled || tabFinanceDisabled" class="b_iconaction" size="sm">
								<i class="fa fa-remove"></i>
							</b-button>
						</b-col>
						<b-col cols="2">
							<div v-if="povracilo.ujemajocePovraciloDataId != null" v-bind:id="'tooltip-povraciloData-' + povracilo.ujemajocePovraciloDataId"  @mouseover="getPovraciloDataInfo(povracilo.ujemajocePovraciloDataId)">
								<currency-input v-model="povracilo.ujemajocePovraciloDataZnesek" class="form-control prilivZnesek" disabled />
							</div>
							<b-tooltip v-bind:target="'tooltip-povraciloData-' + povracilo.ujemajocePovraciloDataId" triggers="hover">
								Datum: <b>{{ povraciloDataHover.creditnotedate | hr_date }}</b> <br>
								Znesek: <b>{{ povraciloDataHover.amount  | hr_money }}</b> <br>
								Action name: <b>{{ povraciloDataHover.action_name }}</b> <br>
								Sale channel: <b>{{ povraciloDataHover.sale_channel }}</b>
							</b-tooltip>
						</b-col>
					</b-row>
					<b-row v-for="povraciloDataBrezUjemanja in povracilaDataBrezUjemanja" v-bind:key="'povraciloDataBrezUjemanja-' + povraciloDataBrezUjemanja.id" class="r_placilo">
						<b-col cols="10">
						</b-col>
						<b-col cols="2">
							<div v-bind:id="'tooltip-povraciloDataBrezUjemanja-' + povraciloDataBrezUjemanja.id"  @mouseover="getPovraciloDataInfo(povraciloDataBrezUjemanja.id)">
								<currency-input v-model="povraciloDataBrezUjemanja.amount" class="form-control povracilaDataBrezUjemanja" disabled />
							</div>
							<b-tooltip v-bind:target="'tooltip-povraciloDataBrezUjemanja-' + povraciloDataBrezUjemanja.id" triggers="hover">
								Datum: <b>{{ povraciloDataHover.creditnotedate | hr_date }}</b> <br>
								Znesek: <b>{{ povraciloDataHover.amount  | hr_money }}</b> <br>
								Action name: <b>{{ povraciloDataHover.action_name }}</b> <br>
								Sale channel: <b>{{ povraciloDataHover.sale_channel }}</b>
							</b-tooltip>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="7"><h5 class="placila_sekcija">Skupaj:</h5></b-col>
						<b-col  cols="2" class="l_izracun">
							<b-form-input type="text" v-model="sestevekPovracilaFormatted" disabled :class="sestevekPovracilaClass"></b-form-input>
						</b-col>
						<b-col cols="1"></b-col>
						<b-col cols="2" class="l_izracun">
							<b-form-input type="text" v-model="povracilaDataSkupaj" disabled class="input_total"></b-form-input>
						</b-col>
					</b-row>
				</b-tab>
				<b-tab title="Oprema">
					<b-row>
						<b-col><h5 class="placila_sekcija">Dodatna oprema (prodana/darilo)</h5></b-col>
					</b-row>
					<b-row v-if="!modalDisabled">
						<b-col cols="3">
							<b-form-group>
								<label>Naziv:</label>
								<v-select ref="tipOpreme"
									v-model="nova_oprema.tip"
									:options="tipi_opreme"
									:create-option="tipOpreme_createOption"
									:taggable="true"
									:filterable="false"
									placeholder="Izberi naziv ...">
									<template slot="option" slot-scope="option">
										{{ option.label }}
									</template>
									<template slot="selected-option" slot-scope="option">
										{{ option.label }}
									</template>
								</v-select>
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group label="Opomba:">
								<b-form-input v-model="nova_oprema.opomba" class="form-control" />
							</b-form-group>
						</b-col>
						<b-col cols="3">
							<b-form-group label="Naročeno:" label-for="datum_narocila">
								<v-date-picker
									ref="datumNarocila"
									id="datum_narocila"
									v-model="nova_oprema.datum_narocila"
									:max-date="new Date(Date.now())"
									:is-required="true"
									:input-props='{
										class: "form-control dt_border gdt_border",
										placeholder: "DD. MM. YYYY",
										required: true
									}'
									mode="single"
									locale="sl-SI" />
							</b-form-group>
						</b-col>
						<b-col cols="2">
							<b-form-group label="Znesek:">
								<currency-input v-model="nova_oprema.znesek" class="form-control" />
							</b-form-group>
						</b-col>
						<b-col cols="1">
							<b-button @click.stop="click_addOprema($event.target)" class="b_akcija b_iconaction" size="sm">
								<i class="fa fa-plus"></i>
							</b-button>
						</b-col>
					</b-row>
					<b-row v-for="item in oprema" v-bind:key="'oprema-' + item.id" class="r_placilo">
						<b-col cols="3">
							<b-form-input type="text" v-model="item.tip" :disabled="modalDisabled"></b-form-input>
						</b-col>
						<b-col cols="3">
							<b-form-input v-model="item.opomba" class="form-control" :disabled="modalDisabled" />
						</b-col>
						<b-col cols="3">
							<v-date-picker v-if="!modalDisabled"
								v-model="item.datum_narocila"
								:max-date="new Date(Date.now())"
								:input-props='{
									class: "form-control dt_border gdt_border",
									placeholder: "DD. MM. YYYY"
								}'
								mode="single"
								locale="sl-SI" />
							<b-form-input v-else :value="item.datum_narocila | hr_date" type="text" disabled></b-form-input>
						</b-col>
						<b-col cols="2">
							<currency-input v-model="item.znesek" class="form-control" :disabled="modalDisabled" />
						</b-col>
						<b-col cols="1">
							<b-button @click.stop="click_removeOprema(item, $event.target)" class="b_iconaction" :disabled="modalDisabled" size="sm">
								<i class="fa fa-remove"></i>
							</b-button>
						</b-col>
					</b-row>
				</b-tab>
				<b-tab title="Bonusi">
					<b-row class="r_povracilo">
						<b-col class="l_znesek">Bonus 1:</b-col>
						<b-col cols="7"><currency-input v-model="bonus1" class="form-control" :disabled="modalDisabled" /></b-col>
						<b-col cols="2"></b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col class="l_znesek">Bonus 2:</b-col>
						<b-col cols="7"><currency-input v-model="bonus2" class="form-control" :disabled="modalDisabled" /></b-col>
						<b-col cols="2"></b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col class="l_znesek">Bonus 3:</b-col>
						<b-col cols="7"><currency-input v-model="bonus3" class="form-control" :disabled="modalDisabled" /></b-col>
						<b-col cols="2"></b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col class="l_znesek">Bonus 4:</b-col>
						<b-col cols="7"><currency-input v-model="bonus4" class="form-control" :disabled="modalDisabled" /></b-col>
						<b-col cols="2"></b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col class="l_znesek">Bonus 5:</b-col>
						<b-col cols="7"><currency-input v-model="bonus5" class="form-control" :disabled="modalDisabled" /></b-col>
						<b-col cols="2"></b-col>
					</b-row>
					<b-row class="r_povracilo">
						<b-col class="l_znesek">Bonus 6:</b-col>
						<b-col cols="7"><currency-input v-model="bonus6" class="form-control" :disabled="modalDisabled" /></b-col>
						<b-col cols="2"></b-col>
					</b-row>
				</b-tab>
				<b-tab title="Prilivi">
					<div v-if="this.prilivi.length">
						<b-row class="prilivTableHeader">
							<b-col cols="2">
								<div>Datum</div>
							</b-col>
							<b-col cols="7">
								<div>Plačnik</div>
							</b-col>
							<b-col cols="2">
								<div>Znesek</div>
							</b-col>
							<b-col cols="1">
								<div>Vir</div>
							</b-col>
						</b-row>
						<b-row v-for="priliv in prilivi" v-bind:key="'priliv-' + priliv.id" class="prilivTable">
							<b-col cols="2">
								<div>{{ priliv.datum | hr_date }}</div>
							</b-col>
							<b-col cols="7">
								<div>{{ priliv.placnik }}</div>
							</b-col>
							<b-col cols="2">
								<div>{{ priliv.znesek | hr_money }}</div>
							</b-col>
							<b-col cols="1">
								<div>{{ priliv.vir }}</div>
							</b-col>
						</b-row>
					</div>
					<div v-else class="text-center">
						Ni prilivov
					</div>
				</b-tab>
				<b-tab title="Povračila">
					<div v-if="this.povracilaData.length">
						<b-row class="povraciloDataTableHeader">
							<b-col cols="2">
								<div>Datum</div>
							</b-col>
							<b-col cols="3">
								<div>Ogrodje</div>
							</b-col>
							<b-col cols="2">
								<div>Znesek</div>
							</b-col>
							<b-col cols="2">
								<div>Action name</div>
							</b-col>
							<b-col cols="3">
								<div>Sale channel</div>
							</b-col>
						</b-row>
						<b-row v-for="povraciloData in povracilaData" v-bind:key="'povraciloData-' + povraciloData.id" class="povraciloDataTable">
							<b-col cols="2">
								<div>{{ povraciloData.creditnotedate | hr_date }}</div>
							</b-col>
							<b-col cols="3">
								<div>{{ povraciloData.chassis }}</div>
							</b-col>
							<b-col cols="2">
								<div>{{ povraciloData.amount | hr_money }}</div>
							</b-col>
							<b-col cols="2">
								<div>{{ povraciloData.action_name }}</div>
							</b-col>
							<b-col cols="3">
								<div>{{ povraciloData.sale_channel }}</div>
							</b-col>
						</b-row>
					</div>
					<div v-else class="text-center">
						Ni povračil
					</div>
				</b-tab>
				<b-tab title="Datoteke">
					<div v-if="mapaExist">
						<b-row>
							<b-col align-self="start" class="datotekeHeader">
								<b>Seznam datotek</b>
							</b-col>
							<b-col align-self="end" class="ma_pos">
								<b-button class="upload" ref="naloziDatoteko" variant="warning" @click.stop="naloziDatoteko_click" size="sm">
									<i class="fa fa-cloud-upload"></i>
								</b-button>
							</b-col>
						</b-row>
						<b-table
						thead-class="hidden_header"
						ref="datotekeTable"
						responsive="xl"
						striped
						show-empty
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						:fields="datotekeTable_fields"
						:items="datoteke">
							<template slot="actions" slot-scope="data">
								<b-button ref="removeDatoteka" variant="primary" @click.stop="removeDatoteka_click(data.item)" size="sm">
									<i class="fa fa-remove"></i>
								</b-button>
								<b-button ref="downloadDatoteka" variant="primary" @click.stop="downloadDatoteka_click(data.item)" size="sm">
									<i class="fa fa-download"></i>
								</b-button>
							</template>
							<template slot="file_type" slot-scope="data">
								<i class="fa no-padding" :class="data.item.file_type"></i>
							</template>
						</b-table>
					</div>
					<div v-else class="text-center">
						Mapa še ni shranjena
					</div>
				</b-tab>
			</b-tabs>
			<b-alert class="error_message" :variant="message.type && message.type === ACTION_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
			<template slot="modal-footer">
				<b-container fluid class="p-0">
					<b-row>
						<b-col align-self="start">
							<b-button variant="warning" :title="gumbPlaciloTitle" @click.stop="click_showPlacila($event.target)" :disabled="placiloDisabled">Plačilo</b-button>
							<b-button variant="warning" v-if="zeljenaIzstavitevRacunaShow" :title="gumbZeljeniRacunTitle" @click.stop="click_showModalZeljenaIzstavitevRacuna($event.target)" :disabled="zeljenaIzstavitevRacunaDisabled">
								<div v-if="zeljenaIzstavitevRacuna != null">Željen račun {{ zeljenaIzstavitevRacuna | hr_datetime }} </div>
								<div v-else>Željen račun</div>
							</b-button>
						</b-col>
						<b-col align-self="end" class="ma_pos">
							<b-button variant="secondary" @click.stop="onCancelModal($event)">Prekliči</b-button>
							<b-button variant="primary" v-if="!modalDisabled" @click.stop="onOkModal($event)">Shrani</b-button>
							<b-button variant="primary" v-else @click.stop="onCancelModal($event)">Zapri</b-button>
						</b-col>
					</b-row>
				</b-container>
			</template>
		</b-modal>
		<placila-modal ref="placilaModal" v-on:userpotrdil-success="on_userPotrdilSuccess" @userpotrdil-canceled="on_userPotrdilCanceled" />
		<zeljena-izstavitev-racuna-modal ref="zeljenaIzstavitevRacunaModal" v-on:success="on_success_zeljenaIzstavitevRacuna"/>
		<dodajanje-st-kupoprodjane-pogodbe-modal ref="dodajanjeStKupoprodajnePogodbeModal" v-on:success="on_success_stKupoprodajnePogodbe"/>
		<edit-priliv-modal ref="editPrilivModal" />
		<nalozi-datoteko-modal @success="onNaloziDatoteko_success" ref="naloziDatotekoModal" />
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>

<style scoped>
@import '../../node_modules/ladda/dist/ladda-themeless.min.css';
.prilivZnesek {
	color: #fff;
	background-color: #4dbd74;
}
.prilivZnesekBrezUjemanja {
	color: #fff;
    background-color: #f86c6b;
}
.cUpdate {
	text-align: right;
}
	.cUpdate button {
		margin-top: 16px;
	}
.error_message {
	margin-top: 1rem;
}
.rb_TipProdaje {
	margin-top: 33px;
}
.rb_DaNe {
	margin-top: 7px;
}
.b_akcija {
	margin-top: 27px;
}
.b_iconaction {
	padding: 0.375rem 0.50rem
}
.placila_sekcija {
	margin-top: 20px;
	margin-bottom: 20px;
}
.l_znesek {
	padding-top: 7px;
}
.l_izracun {
	padding-top: 13px;
}
.r_povracilo {
	margin-top: 10px;
}
.r_razlika {
	margin-top: 10px;
}
.r_placilo {
	margin-bottom: 5px;
}
.positive {
	color: green;
}
.negative {
	color: red;
}
.input_total {
	font-weight: bold;
}
.ma_pos {
	text-align: end;
}
.text-center {
	text-align: center;
}
.b_removePotrdil div {
	position: relative;
}
	.b_removePotrdil input {
		margin-right: 30px;
	}
	.b_removePotrdil button {
		float: right;
	}
.prilivTable {
	margin-top: 15px;
}
.prilivTableHeader {
	font-weight: bold;
	margin-bottom: 10px;
}
.povraciloDataTable {
	margin-top: 15px;
}
.povraciloDataTableHeader {
	font-weight: bold;
	margin-bottom: 10px;
}
.povracilaDataBrezUjemanja {
	color: #fff;
	background-color: #f86c6b;
}
.lockIcon {
	font-size: 1.5em;
	margin-top: 1em;
}
</style>
<style>
.hidden_header {
  display: none;
}
.modal-xl {
    max-width: 1000px;
}
.tdActions {
	width:6rem;
}
.tdIcons {
	width:2rem;
	height: 3rem;
}
.upload {
	margin-bottom:1rem;
}
.datotekeHeader {
	margin-bottom:1rem;
	margin-left:1rem;
}
.buttonKupoprodajnaPogodba {
	padding: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/MapaModal.vue